<ngx-spinner [name]="'next-works'" [fullScreen]="false"></ngx-spinner>

<div>
  <div style="display: flex; flex-direction: row; justify-content: space-between;">
    <h5>{{title}}</h5>
    <button mat-icon-button class="modern-icon-btn mb-2" (click)="refreshComments()" target="_blank" aria-label="Kommentare neu laden">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div *ngIf="canAddNewComment" class="modern-comment-input">
    <textarea [(ngModel)]="newComment"
              class="modern-textarea"
              rows="3"
              placeholder="Kommentar hinzufügen..."></textarea>
    <button (click)="onAddNewComment()"
            class="modern-btn ms-auto"
            style="width: fit-content;"
            [disabled]="newComment === ''">
      Kommentar hinzufügen
    </button>
  </div>

  <div class="alert alert-info mt-2 mb-2" *ngIf="comments.length == 0">Noch keine Kommentare</div>

  <div *ngIf="!!comments && comments.length" class="modern-inventory-table responsive-comments-table" style="margin-top: 1em;">
    <div class="modern-inventory-header">
      <div class="modern-inventory-col col-what">Wer</div>
      <div class="modern-inventory-col col-number">Wann</div>
      <div class="modern-inventory-col col-details">Was</div>
    </div>
    <div class="modern-inventory-row" *ngFor="let item of comments">
      <div class="modern-inventory-col col-what">
        <span class="mobile-label">Wer:</span>
        {{item.author_object?.first_name}} {{item.author_object?.last_name}}
      </div>
      <div class="modern-inventory-col col-number">
        <span class="mobile-label">Wann:</span>
        {{item.updated_at | humanDatePipe}}
      </div>
      <div class="modern-inventory-col col-details">
        <span class="mobile-label">Was:</span>
        {{item.content}}
      </div>
    </div>
  </div>
</div>
